@import '../../theme/global';

:host {
  border-top: 1px solid $gray-200;
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 10px;
  width: 100%;
  @media (min-width: 768px) {
    border-top: none;
    justify-content: normal;
    margin-top: 0;
    padding-top: 0;
    width: auto;
  }
}
